module.exports = __webpack_public_path__ + "static/media/computer.a2276d76.png";